
import Request from './reqeust';

const componey = '';

//企业门店列表
export function getEnterpriseInfo(_params) {
    return Request({
        url: 'api/company/getCompanyInfo',
        method: 'get',
        params: _params
    })
}




// WEBPACK FOOTER //
// ./src/services/qiye.js